import { createModule } from 'terrific-singleton';
import { TerrificSpec } from 'terrific-singleton/terrific-module';

const classes = {
	tabItem: 'js-o-home-scrollable-teaser__tab-item',
	tabItemActive: 'state-o-home-scrollable-teaser__tab-item-active',
	tabItemLink: 'js-o-home-scrollable-teaser__tab-link',
	contentItem: 'o-home-scrollable-teaser__content-item',
	contentItemVisible: 'state-o-home-scrollable-teaser__content-item-visible',
	itemList: 'js-m-scrollable-teaser__list'
};

@createModule('HomeScrollableTeaser')
/**
 * home-scrollable-teaser module implementation.
 */

export class HomeScrollableTeaser extends TerrificSpec {
	$ctx: JQuery;
	$tabItem: JQuery;
	$tabItemLink: JQuery;
	$contentItem: JQuery;

	start(resolve: Function) {
		this.$ctx = $(this._ctx);
		this.$tabItem = $(`.${classes.tabItem}`, this.$ctx);
		this.$tabItemLink = $(`.${classes.tabItemLink}`, this.$ctx);
		this.$contentItem = $(`.${classes.contentItem}`, this.$ctx);

		this.initTab();
		this.$tabItemLink.on('click', this.onSwichTab.bind(this));
		this.onDownLoadCalendar();

		resolve();
	}

	initTab() {
		this.$tabItem.first().addClass(classes.tabItemActive);
		this.$contentItem.first().addClass(classes.contentItemVisible);
	}

	onSwichTab(ev: any) {
		$(ev.currentTarget).parent().addClass(classes.tabItemActive);
		$(ev.currentTarget).parent().siblings().removeClass(classes.tabItemActive);
		this.$contentItem.removeClass(classes.contentItemVisible);

		let tabItemIndex = $(ev.currentTarget).parent().index();
		this.$contentItem.eq(tabItemIndex).addClass(classes.contentItemVisible);
        let currentContentItemWidth = this.$contentItem.eq(tabItemIndex).find(`.${classes.itemList}`).width();

		if (this.$contentItem.eq(tabItemIndex).width() >= currentContentItemWidth) {
            this.$contentItem.eq(tabItemIndex).addClass('m-scrollable-teaser--disabled-silder');
        }
	}

	private onDownLoadCalendar()
    {
        $(document).off("click").on("click",".js-a-download", function () {
			var calendarResult = $(this).attr("data-calendarresult");
			if (calendarResult != undefined) {
				if (calendarResult.length > 0) {

					window.open( "data:text/calendar;charset=utf8," +calendarResult);
				} else {
					console.log("calendarResult: calendarResult is empty");
				}
			}
			else {
				console.log("calendarResult: calendarResult is undefined");
			}

		});
    }

	stop() { }
}
